import Chip from '@mui/material/Chip';

export type ChipTone = 'neutral' | 'info' | 'warning' | 'success' | 'error' | 'gold';

const TONES: Record<ChipTone, { bg: string; fg: string }> = {
  neutral: { bg: 'var(--color-bg-subtle, #F1F5F9)', fg: '#475569' },
  info: { bg: '#E0F2FE', fg: '#0369A1' },
  warning: { bg: '#FEF3C7', fg: '#92400E' },
  success: { bg: '#DCFCE7', fg: '#166534' },
  error: { bg: '#FEE2E2', fg: '#991B1B' },
  gold: { bg: 'rgba(200,169,110,0.18)', fg: '#7A5F27' },
};

const TONE_BY_STATUS: Record<string, ChipTone> = {
  // referrals
  REGISTERED: 'info',
  ONBOARDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  // onboarding
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
  // rewards
  PENDING_APPROVAL: 'warning',
  CREDITED: 'gold',
  REVERSED: 'neutral',
  // activities
  AVAILABLE: 'neutral',
  SUBMITTED: 'info',
  PENDING_VERIFICATION: 'warning',
  // merch
  REQUESTED: 'info',
  PROCESSING: 'info',
  SHIPPED: 'info',
  DELIVERED: 'success',
  RECEIVED: 'success',
  CANCELLED: 'neutral',
  OUT_OF_STOCK: 'warning',
  // photos
  PENDING: 'neutral',
  REVIEW_REQUIRED: 'warning',
};

export function toneFor(status: string): ChipTone {
  return TONE_BY_STATUS[status] ?? 'neutral';
}

export function RewardChip({ label, status, tone }: { label: string; status?: string; tone?: ChipTone }) {
  const colors = TONES[tone ?? (status ? toneFor(status) : 'neutral')];
  return (
    <Chip
      label={label}
      size="small"
      sx={{ bgcolor: colors.bg, color: colors.fg, fontWeight: 700, fontSize: '0.72rem', height: 24 }}
    />
  );
}
